<template>
	<div class="contract-list">
		<el-row class="filter-wrap" :gutter="20">
			<el-col :span="5">
				<el-input clearable v-model="page.nameOrCode" size="small" placeholder="框架合同名称/编号" @keyup.enter.native="onSearch">
				</el-input>
			</el-col>
			<el-col :span="5">
				<el-input clearable v-model="page.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
			</el-col>
			<el-col :span="4" class="input-group">
				<el-input clearable v-model="page.businessPrincipal" size="small" placeholder="有花果对接负责人" @keyup.enter.native="onSearch"></el-input>
			</el-col>
			<el-col :span="4" class="input-group">
				<el-input clearable v-model="page.sealApplyName" size="small" placeholder="盖章申请人" @keyup.enter.native="onSearch"></el-input>
			</el-col>
			<el-col :span="4">
				<el-button type="primary" size="small" @click="onSearch">查询</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 30px;">框架合同总数：{{page.total||0}}条</div>
		<div class="table-wrap">
			<el-table v-loading="tableLoading" :data="tableData" size="small">
				<el-table-column label="框架合同信息" prop="bankSerialNumber" align="center">
					<template slot-scope="scope">
						<div>合同名称：{{scope.row.name}}</div>
						<div>合同编号：{{scope.row.code}}</div>
					</template>
				</el-table-column>
				<el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
				<el-table-column label="客户类型" prop="customerType" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.customerType==1">品牌方</span>
							<span v-else-if="scope.row.customerType==2">Agency</span>
					</template>
				</el-table-column>
				<el-table-column label="合同状态" prop="status" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.status==1">洽谈中</span>
							<span v-else-if="scope.row.status==2">已签约</span>
					</template>
				</el-table-column>
				<el-table-column label="对接负责人" prop="principalName" align="center"></el-table-column>
				<el-table-column label="框架协议文件" prop="fileList" align="center">
				  <template slot-scope="scope">
					<filePreview :fileList="scope.row.fileList"></filePreview>
					<span v-if="scope.row.fileList==null">暂无</span>
					<!-- <a style="display: block;" v-for="(item,index) in scope.row.fileList" v-if="item.fileType==2" :key='index' class="link" href="javascript:void(0);" @click="downloadFile(item.path,item.name)" :download="item.path">{{item.name}}</a> -->
				  </template>
				</el-table-column>
				<el-table-column label="盖章申请人" prop="sealApplyUserName" align="center"></el-table-column>
				<el-table-column label="盖章申请时间" prop="sealApplyTime" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="goSee(scope.row.id)">查看</el-button>
						<template v-if="permissions.agreement_stamped">
							<el-button type="text" size="small" @click="gz(scope.row.id)">盖章</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="pagination-wrap">
				<el-pagination background @size-change="sizeChange" @current-change="currentChange"
					:current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
					layout="sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
			<!-- 分页 -->
		</div>
	</div>
</template>

<script>
	import * as qiniu from "qiniu-js"; 
	import { qiniuToken } from "@/api/index";
	import XLSX from "xlsx";
	import {
		mapGetters
	} from "vuex";
	import validate from "@/util/validate";
	import util from "@/util/util";
	import {
		contractConfig
	} from "@/const/config/contract";
	import InvoiceFormFields from "@/const/form/InvoiceForm";
	import {
		billingConfig
	} from "@/const/config/billing";
	import {
		getXygzList,GZbtn
	} from "@/views/business/frameAccord/index";
	import {
		processList
	} from "@/api/approve/contract";
	import approveList from "@/components/common/approveMember";
	export default {
		components: {

		},
		data() {
			// 开票金额判断
			var validPrice = (rule, value, callback) => {
				let money = this.remainingMoney;
				if (!validate.checkNull(value)) {
					let err = validate.checkAmount(value, money);
					if (err) {
						callback(new Error(err));
					}
					callback();
				}
				callback();
			};
			return {
				voucher:'',//上传回款凭证
				drBack:{},//导入返回数据
				drhkStatus:false,//导入状态开关
				hkid:'',//合同id
				zfForm:{
					"id":null,
					"returnMoneyId":null,
					"contractId": null,
					"reason":"",
					"deleteFlag": 0
				},
				hkType:[
						  {label:'商务合同回款',value:1},
						  {label:'品牌合同回款',value:2},
				],//回款类型
				rlList:[
						  {label:'未认领',value:1},
						  {label:'部分认领',value:2},
						  {label:'完全认领',value:3},
				],//认领状态1未认领 2部分认领 3完全认领
				zfData:{},//作废信息
				rlData:[],//认领记录
				fileList: [], //凭证
				billingConfig,
				uphkVisible:false,//上传回款凭证
				approveVisible: false,
				approveLoading: false,
				Invoicedialog: false, //回款详情
				approveTitle: false,
				invoiceVisible: false, //作废详情
				zftxVisible: false, //作废提醒
				drhkVisible: false, //导入回款
				/**
				 * 开票提醒模块
				 */
				isUploadFile: false, //是否上传
				hasCorrectIncome: false, //KOL收入+有花果收入=净收入
				hasRemainingMoney: false, //剩余金额大于可开票金额


				contractConfig: contractConfig,
				form: {
					nameOrCode: "",
					customerName: "",
					contractMoneyMin: "",
					contractMoneyMax: "",
					statusList: "",
				},
				  InvoiceForm: {
						account: "",
						bankAccount: null,
						bankDeposit: "",
						bankSerialNumber: "",
						claimMoney: null,
						createTime: "",
						createUserId: "",
						createUserName: "test",
						deleteFlag: null,
						payeeName: "",
						payer: "",
						remark: "",
						returnMoney: 0,
						returnTime: "",
						returnType: 1,
						status: 1,
						voucher: "",
						waitClaimMoney: 0,
				  },
				rules: {
					invoiceMoney: [{
							required: true,
							message: "请输入合同金额",
							trigger: "blur"
						},
						{
							validator: validPrice,
							trigger: "blur"
						},
					],
				},
				  page: {
					pageNum: 1,
					pageSize: 10,
					total: 0,
					businessPrincipal:'',//业务负责人
					customerName:'',//客户名称
					nameOrCode:'',//合同框架名称/编号
					sealApplyName:'',//盖章申请人
					status:4,//盖章状态 4-待盖章；5-已盖章
				  },
				  rlpage:{
				  		  pageNum: 1,
				  		  pageSize: 10,
				  		  total: 0,
				  },//认领列表分页
				submitLoading: false,
				tableData: [],
				tableLoading: false,
				/**
				 * 业务负责人模块
				 */
				adminListModal: false,
				adminPage: {
					pageSize: 10,
					pageNum: 1,
					total: 0,
				},
				adminForm: {
					queryString: "",
				},
				selectAdminId: null,
				selectAdmin: null,
				adminTable: [],
				adminTableLoading: false,
				pid: null,
			};
		},
		mounted() {
			this.getList();
		},
		computed: {
			...mapGetters(["permissions", "dicts"]),
		},
		methods: {
			//回款凭证上传获取路径
			beforeUpload2(file){
						 console.log(1111111,file)
						  qiniuToken()
						    .then((res) => {
						      let that = this;
						      let fileName = Date.now() + file.name;
						      var observable = qiniu.upload(file, fileName, res.data);
						      observable.subscribe({
						        next(res) {
						          console.log("upload...", res);
						        },
						        error(error) {
						          this.$message.error("上传失败");
						          console.log("error", error);
						        },
						        complete: (complete) => {
						          console.log("complete");
						          let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
						          this.$set(this.form, "fileName", file.name);
						          this.$set(this.form, "path", qiniuBaseUrl + complete.key);
								  console.log(qiniuBaseUrl + complete.key)
									  this.voucher = qiniuBaseUrl + complete.key
			
						        },
						      });
						    })
						    .catch((error) => {});
						  return false;
						},
			//上传方法
		 beforeUpload(file) {
			 console.log(1111111,file)
			 let formData = new FormData();
			     formData.append("file", file);
				 console.log(formData)
				 drSub(formData)
				  .then((res) => {
				 	if(res.code==1){
						this.drBack = res.data
				 		this.drhkVisible = false
				 		this.drhkStatus = true
				 	}
				  })
				  .catch((err) => {
				 					  			
				  });
			},
			// 盖章
			gz(id) {
				this.$confirm('确认盖章吗?', '提示', {
					cancelButtonText: '取消',
					confirmButtonText: '确定',
					type: 'warning'
				}).then(() => {
					var obj = {
						id : id
					}
					GZbtn(obj)
					  .then((res) => {
							if(res.code==1){
								this.getList();
								this.$message({
									type: 'success',
									message: '盖章成功!',
								});
								setTimeout(()=>{
									this.$router.go(0)
								},500)
							}
					  })
					  .catch((err) => {
								
					  });
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//跳转查看
			goSee(id) {
				let router = this.$router.resolve({
					path: "/frame/see",
					query: {
						id: id,
					},
				});
				window.open(router.href, "_blank");
			},
			//打开认领记录
			openrlList(id){
					this.approveVisible = true
					this.hkid = id
					this.getRl();
			},
			// 获取认领记录
			getRl(){
				let obj = {
					id:this.hkid,
					pageNum:this.rlpage.pageNum,
					pageSize:this.rlpage.pageSize,
				}
				rlList(obj)
				  .then((res) => {
						console.log('我是认领记录',res)
						this.rlData = res.data
						this.rlpage.total = res.total;
						console.log('我是认领记录总数',this.rlpage.total)
				  })
				  .catch((err) => {
							
				  });
			},
			//点击作废
			zfClick(row) {
				console.log(row)
				this.zfForm.contractId = row.contractId
				this.zfForm.id = row.id
				this.zfForm.returnMoneyId = row.returnMoneyId
				this.zftxVisible = true
			},
			// 上传凭证
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			/**重新提交 */
			reSubmit(contractId) {
				this.$confirm("确认重新提交启动审批?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						reapply({
							contractId
						}).then((res) => {
							this.$message.success("重新提交成功");
							this.getList();
						});
					})
					.catch(() => {});
			},
			/**
			 * 业务负责人模块
			 */
			//打开资源选择弹窗
			onOpenAdminSelectModal(username, id, pid) {
				if (username) {
					this.selectAdmin = {
						username,
						id,
					};
				} else {
					this.selectAdmin = null;
				}
				this.pid = pid;
				this.adminListModal = true;
			},
			//资源选择弹窗打开
			openAdminSelectModal() {
				this.adminForm.queryString = "";
				this.selectAdminId = null;
				this.onAdminSearch();
			},
			//资源标签删除
			onAdminTagClose() {
				this.selectAdmin = null;
				this.selectAdminId = null;
			},
			//资源弹窗关闭
			onConfirmAdminChoose() {
				if (this.selectAdmin) {
					let obj = {
						businessPrincipalId: this.selectAdmin.id,
						contractId: this.pid,
					};
					editAdmin(obj)
						.then((res) => {
							if (res.code == 1) {
								this.$message.success("分配成功！");
								this.getList();
							}
						})
						.catch((err) => {});
					this.adminListModal = false;
				} else {
					this.$message.error("不能删除业务负责人！");
				}
			},
			/**认领列表
			 * 监听分页器每页显示的条数变化
			 * @param val 条数
			 */
			rlSizeChange(val) {
			  this.rlpage.pageNum = 1;
			  this.rlpage.pageSize = val;
			  this.getRl();
			},
			/**认领列表
			 * 监听页数变化
			 * @param val 当前页数
			 */
			rlCurrentChange(val) {
			  this.rlpage.pageNum = val;
			  this.getRl();
			},
			//资源搜索
			onAdminSearch() {
				this.adminPage.pageNum = 1;
				this.getAdminList();
			},
			//获取资源列表
			getAdminList() {
				let obj = {
					pageSize: this.adminPage.pageSize,
					pageNum: this.adminPage.pageNum,
				};
				if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
					obj.usernameOrPhone = this.adminForm.queryString.trim();
				}
				this.adminTableLoading = true;
				listAdmin(obj)
					.then((res) => {
						this.adminTable = res.data || [];
						this.adminPage.total = res.total;
						this.adminTableLoading = false;
					})
					.catch((err) => {
						this.adminTable = [];
						this.adminPage.total = 0;
						this.adminTableLoading = false;
					});
			},
			//资源选择变化
			onChangeAdmin(val) {
				console.log(this.selectAdminId);
				this.selectAdmin = this.adminTable.find((v) => v.id == val);
			},

			//提交
			onSubmit() {
				this.$refs.InvoiceForm.validate((valid, obj) => {
					if (valid) {
						let f = util.deepClone(this.InvoiceForm);
						InvoiceAdd(f).then((res) => {
							if (res.code == 1) {
								this.$message.success("申请成功！");
								this.Invoicedialog = false;
								this.getList();
							}
						});
					} else {
						let a = Object.keys(obj).map((v) => {
							let text = "";
							if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
								let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
								text = InvoiceFormFields.list[fieldInArray];
							} else {
								text = InvoiceFormFields.list[v];
							}
							return text;
						});
						this.$message.error(
							"表单不完整！请检查" + a.join("、") + "是否按要求填写"
						);
					}
				});
			},
			/**
			 * 监听分页器每页显示的条数变化
			 * @param val 条数
			 */
			sizeChange(val) {
				this.page.pageNum = 1;
				this.page.pageSize = val;
				this.getList();
			},
			/**
			 * 监听页数变化
			 * @param val 当前页数
			 */
			currentChange(val) {
				this.page.pageNum = val;
				this.getList();
			},

			// 搜索
			onSearch() {
				if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
					if (
						parseInt(this.form.contractMoneyMin) >
						parseInt(this.form.contractMoneyMax)
					) {
						this.$message.error("最小合同金额不能大于最大合同金额");
						return;
					}
				}
				this.page.pageNum = 1;
				this.getList();
			},
			// 获取列表
			getList() {
			  this.tableLoading = true;
			  getXygzList(this.page)
				.then((res) => {
					console.log(res)
				  this.tableData = res.data || [];
				  this.page.total = res.total;
				  this.tableLoading = false;
				})
				.catch((err) => {
					
				});
			},
			/**
			 * 数字可读化
			 * @param num 数字
			 */
			readableNum(num) {
				if (!num && num !== 0) return "";
				return util.priceFormat(num);
			},
		},
		watch: {
			Invoicedialog(val) {
				if (!val) {
					this.InvoiceForm = {
						contractId: null, //合同ID
						customerName: "", //名称
						companyPhone: "", //电话
						companyAddress: "", //公司地址
						taxpayerId: "", //纳税人识别号
						customerBank: "", //客户开户行
						customerBankAccount: "", //客户银行账户
						invoiceMoney: "", //开票金额
						invoiceType: "", //发票类型
						invoiceDetail: "", //开票明细
						remark: "", //合同备注
					};
					this.$refs.InvoiceForm.clearValidate("invoiceMoney");
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.dz-img {
		display: block;
		width: 90px;
		height: 100px;
		margin: 0 auto;
	}

	.dz-title {
		font-size: 30px;
		color: #000;
		font-weight: bold;
		text-align: center;
		padding: 10px;
	}

	.dz-text {
		text-align: center;
		padding: 20px;
	}

	.dz-info {
		display: flex;
		justify-content: space-around;
		padding: 20px;
	}

	.table-wrap {
		margin-top: 20px;
	}

	.mar-c {
		display: flex;
		justify-content: center;
	}

	.table-count {
		margin: 15px 0 10px;
	}

	// 列表item
	.block-form-item {
		&.w-32 {
			display: inline-block;
			width: 32%;
			margin-right: 1%;
			height: 64px;
		}

		&.w-99 {
			width: 99%;
			margin-right: 1%;
		}
	}

	.yhg-dialog {
		.select-con {
			display: flex;

			.label {
				white-space: nowrap;
			}

			.select-tag {
				margin-right: 5px;
				margin-bottom: 5px;
			}

			.select-tag-text {
				display: inline-block;
				max-width: 86px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.filter-con {
			display: flex;
			align-items: center;
			margin: 20px 0;
			width: 800px;

			.label {
				white-space: nowrap;
			}

			.search-btn {
				margin-left: 15px;
			}
		}

		.submit-con {
			margin-top: 20px;
			text-align: right;
		}
	}

	.select-input-wrap-s {
		.el-input-group__append {
			position: relative;
			width: 32px;
			height: 32px;
			border: none;
			background: #fff;
			padding: 0;
			color: #409eff;

			.iconfont {
				position: absolute;
				top: -2px;
				left: -1px;
				font-size: 33px !important;
			}

			cursor: pointer;
		}
	}

	.select-con {
		.el-tag .el-icon-close {
			top: -8px;
		}
	}

	.avue-view .cost-table {
		width: calc(50% + 100px);

		th {
			background: none;
			font-weight: normal;
			font-size: 14px;
		}

		.cell {
			padding-left: 0;
		}
	}

	.el-table .operate-column {
		vertical-align: text-top;
	}

	/deep/.el-dialog__header {
		border-bottom: 1px solid #ccc !important;
	}

	.invoiceList {
		display: flex;
		justify-content: space-between;
	}

	.mt-10 {
		margin-top: 10px;
	}
</style>
